import axios from 'axios'
import { generateToken } from '../../http-common'
import config from '../config'

const responseBody = (res: any) => res.data

const DEFAULT_HEADERS = {
  channel: 'APP',
  source: 'PORTAL_USER',
  'source-id': 'PORTAL',
  version: '2021-07-28'
}

const requests = {
  get: (
    url: string,
    headers: { [key: string]: string },
    params?: { [key: string]: any },
    baseDomain: string = config.restApiUrl
  ) =>
    axios({
      url: baseDomain + url,
      method: 'GET',
      headers: headers,
      params: params
    }).then(responseBody),
  post: (
    url: string,
    body: any,
    headers: { [key: string]: string },
    baseDomain: string = config.restApiUrl
  ) =>
    axios({
      url: baseDomain + url,
      method: 'POST',
      headers: headers,
      data: body
    }).then(responseBody),
  put: (
    url: string,
    body: any,
    headers: { [key: string]: string },
    baseDomain: string = config.restApiUrl
  ) =>
    axios({
      url: baseDomain + url,
      method: 'PUT',
      headers: headers,
      data: body
    }).then(responseBody),
  delete: (
    url: string,
    headers: { [key: string]: string },
    baseDomain: string = config.restApiUrl
  ) =>
    axios({
      url: baseDomain + url,
      method: 'DELETE',
      headers: headers
    }).then(responseBody)
}

const ClientPortal = {
  getUserByContactId: async (locationId: string, contactId: string) => {
    const token = await generateToken()
    return requests.get(`/clientclub/${locationId}/users/${contactId}`, {
      ...DEFAULT_HEADERS,
      'source-id': locationId,
      'token-id': token
    })
  },
  getPortalSettings: (domain: string) => requests.get(`/clientclub/portal-settings?domain=${domain}`, DEFAULT_HEADERS) 
}

export default { ClientPortal }
